import React, { createContext, useContext, useState, useCallback } from 'react';

const CommentValidationContext = createContext();

export const CommentValidationProvider = ({ children }) => {
  const [hasCommented, setHasCommented] = useState(false);
  const [saveCommentTrigger, setSaveCommentTrigger] = useState(null);

  const markAsCommented = () => {
    setHasCommented(true);
  };

  const resetCommentStatus = () => {
    setHasCommented(false);
  };

  const validateCommentRequired = () => {
    if (!hasCommented) {
      alert("Debe ingresar un comentario");
      return false;
    }
    return true;
  };

  const triggerSaveComment = (callback) => {
    setSaveCommentTrigger(() => callback);
  };

  const executeSaveComment = () => {
    if (saveCommentTrigger) {
      saveCommentTrigger();
      setSaveCommentTrigger(null);
    }
  };

  const value = {
    hasCommented,
    markAsCommented,
    resetCommentStatus,
    validateCommentRequired,
    triggerSaveComment,
    executeSaveComment,
    saveCommentTrigger
  };

  return (
    <CommentValidationContext.Provider value={value}>
      {children}
    </CommentValidationContext.Provider>
  );
};

export const useCommentValidation = () => {
  const context = useContext(CommentValidationContext);
  if (!context) {
    // Return default functions when no provider is available
    return {
      hasCommented: true, // Default to true so validation passes
      markAsCommented: () => {}, // No-op function
      resetCommentStatus: () => {}, // No-op function
      validateCommentRequired: () => true, // Always returns true (validation passes)
    };
  }
  return context;
};

export default CommentValidationContext; 